import { render } from "./RequisitionReportsPage.vue?vue&type=template&id=ac9a07da"
import script from "./RequisitionReportsPage.vue?vue&type=script&lang=js"
export * from "./RequisitionReportsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__